import { CycleUtils, getSearchParams, PREMIUM_PLAN_PRODUCT_TYPE_ID } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components';
import { useAnonymous } from './useAnonymous';
import { useIsSeasonalSale } from './useIsSeasonalSale';
export const useRevShare = props => {
  var _currentProductQuery$;
  const siteGuid = getSearchParams().siteGuid;
  const {
    isAnonymous
  } = useAnonymous();
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const productId = (props == null ? void 0 : props.productId) ?? selectedProductId;
  const currentProductQuery = module.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const hasExistingSubscription = !!((_currentProductQuery$ = currentProductQuery.data) != null && _currentProductQuery$.currentProduct);
  const currencyQuery = module.SDK.studioOfferingApiClient.hooks.useFetchCurrency({});
  const isSeasonalSale = useIsSeasonalSale();
  const shouldFetchRevShare = currentProductQuery.isSuccess && !hasExistingSubscription && !!productId && !!siteGuid && !isAnonymous && !isSeasonalSale;
  const revShareQuery = module.SDK.revShareApiClient.hooks.useGetProductRevshareAmounts({
    productId: productId ?? '',
    siteGuid: siteGuid ?? '',
    productTypeId: PREMIUM_PLAN_PRODUCT_TYPE_ID
  }, shouldFetchRevShare);
  const isLoading = currencyQuery.isLoading || revShareQuery.isLoading || currentProductQuery.isLoading;
  const isError = currencyQuery.isError || revShareQuery.isError || currentProductQuery.isError;
  const getRevShareAmountPerCycle = cycle => {
    var _revShareQuery$data;
    return ((_revShareQuery$data = revShareQuery.data) == null || (_revShareQuery$data = _revShareQuery$data.amounts) == null || (_revShareQuery$data = _revShareQuery$data.find(r => CycleUtils.isCycleEqual(r.cycle, cycle))) == null ? void 0 : _revShareQuery$data.amount) ?? 0;
  };
  const getRevShareAmounts = () => {
    var _revShareQuery$data2;
    return ((_revShareQuery$data2 = revShareQuery.data) == null ? void 0 : _revShareQuery$data2.amounts) ?? [];
  };
  const getMaxRevShareAmount = () => {
    var _revShareQuery$data3;
    const allAmounts = ((_revShareQuery$data3 = revShareQuery.data) == null || (_revShareQuery$data3 = _revShareQuery$data3.amounts) == null ? void 0 : _revShareQuery$data3.map(amount => amount.amount)) ?? [];
    return Math.max(...allAmounts);
  };
  const hasRevShare = getRevShareAmounts().some(r => r.amount > 0);
  return {
    getRevShareAmountPerCycle,
    getRevShareAmounts,
    getMaxRevShareAmount,
    hasRevShare,
    isLoading,
    isError
  };
};
//# sourceMappingURL=useRevShare.js.map